import React from 'react';
import { Header } from 'components/Header';
import { Main } from 'components/Main';
import { Footer } from 'components/Footer';
import { Loader } from 'components/Loader';
import { FullHeightLayout } from 'components/Common/styled-components';

export const SuspenseLoader = () => {
  return (
    <FullHeightLayout>
      <Header />
      <Main>
        <Loader open={true} />
      </Main>
      <Footer />
    </FullHeightLayout>
  );
};
